import type { ConsentPayloadDTO } from "@/core/types";
import { patientRequestsTyped } from "@/api/patientTyped";

/** We want to explicitly opt-out from the default loading spinner to show skeletons and do optimistic updates */
const params = {
  showLoader: false,
};

export async function appendPatientConsent(data: ConsentPayloadDTO) {
  return patientRequestsTyped.append_patient_consent({ data, params });
}
